module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-create-zone"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column small-12 large-6"
  }, [_c('label', [_vm._v("Select zone"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.zone_id),
      expression: "body.zone_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "zone_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select zone")]), _vm._l((_vm.zones), function(zone, id) {
    return _c('option', {
      domProps: {
        "value": zone.id
      }
    }, [_vm._v(_vm._s(zone.name))])
  })], 2)])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Type"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.type),
      expression: "body.type"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.type)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "type", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Color"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.color),
      expression: "body.color"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "color", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("On reservation start")]), _c('SelectizeCommonCost', {
    attrs: {
      "selectedValue": _vm.body.start_common_cost_id
    },
    on: {
      "optionSelected": function($event) {
        return _vm.setCommonCost('start_common_cost_id', $event)
      },
      "optionRemoved": function($event) {
        return _vm.unsetCommonCost('start_common_cost_id')
      }
    }
  }), _c('label', [_vm._v("Show on public map")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.show),
      expression: "body.show"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.body.show) ? _vm._i(_vm.body.show, null) > -1 : (_vm.body.show)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.body.show,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.body, "show", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.body, "show", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.body, "show", $$c)
        }
      }
    }
  })], 1), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("On reservation end")]), _c('SelectizeCommonCost', {
    attrs: {
      "selectedValue": _vm.body.end_common_cost_id
    },
    on: {
      "optionSelected": function($event) {
        return _vm.setCommonCost('end_common_cost_id', $event)
      },
      "optionRemoved": function($event) {
        return _vm.unsetCommonCost('end_common_cost_id')
      }
    }
  }), _c('label', [_vm._v("Max vehicles"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.max_vehicles),
      expression: "body.max_vehicles"
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.body.max_vehicles)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "max_vehicles", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Min fuel level"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.min_fuel_level),
      expression: "body.min_fuel_level"
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.body.min_fuel_level)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "min_fuel_level", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Max speed"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.max_speed),
      expression: "body.max_speed"
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.body.max_speed)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "max_speed", $event.target.value)
      }
    }
  })])], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.save
    }
  }, [_vm._v("Save")])], 1)]), _c('div', {
    staticClass: "row column"
  }, [_c('GoogleMapContainer', [_c('GoogleMap', {
    ref: "map",
    staticStyle: {
      "height": "500px"
    },
    attrs: {
      "api-key": _vm.apiKey,
      "center": _vm.mapCenter,
      "libraries": ['places', 'visualization', 'drawing'],
      "zoomControl": true,
      "mapTypeControl": true
    }
  }, _vm._l((_vm.selectedPoly), function(p) {
    return (_vm.body.zone_id !== null) ? _c('google-map-polygon', {
      attrs: {
        "positions": p,
        "color": _vm.body.color,
        "fillColor": _vm.body.color
      }
    }) : _vm._e()
  }), 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-879cfb82!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/ZoneConfigForm.vue
// module id = 2632
// module chunks = 1